import { FREE_TRADE_LIMIT } from './planFeatures';

const TRIAL_DAYS = 7;
const PAID_PLANS = ['pro', 'elite'];

/**
 * Returns trial/subscription status from a Firestore subscription doc.
 * @param {object|null} subscription — doc from subscriptions/{uid}
 * @returns {{ status: 'paid' } | { status: 'active', daysLeft: number } | { status: 'expired' }}
 */
export const getTrialStatus = (subscription) => {
  if (!subscription) return { status: 'paid', legacy: true };

  if (PAID_PLANS.includes(subscription.planId) || PAID_PLANS.includes(subscription.plan)) {
    return { status: 'paid' };
  }

  // Legacy users predate the trial system — no trialStartDate and not on 'trial' plan.
  // Treat them as paid so nothing breaks for existing accounts.
  if (!subscription.trialStartDate && subscription.plan !== 'trial') {
    return { status: 'paid', legacy: true };
  }

  const startRaw = subscription.trialStartDate;
  if (!startRaw) return { status: 'expired' };

  const daysSinceStart = (Date.now() - new Date(startRaw).getTime()) / (1000 * 60 * 60 * 24);
  const daysLeft = Math.max(0, Math.ceil(TRIAL_DAYS - daysSinceStart));

  return daysLeft > 0
    ? { status: 'active', daysLeft }
    : { status: 'expired' };
};

/**
 * Returns true if the user can add another trade.
 * Paid users have no limit; active trial users are capped at FREE_TRADE_LIMIT.
 */
export const canAddTrade = (trialStatus, tradeCount) => {
  if (trialStatus.status === 'paid') return true;
  if (trialStatus.status === 'active') return tradeCount < FREE_TRADE_LIMIT;
  return false;
};

/**
 * Returns true if the user can access paid features (paid plan or active trial).
 */
export const canAccessFeature = (trialStatus) => {
  return trialStatus.status === 'paid' || trialStatus.status === 'active';
};
